/** @format */

import React from "react";

function Fixer({ c, setC, bc, setBc }) {
  const changeBox = (status, h, s, b) => {
    let d = [...c];
    let cb = [...bc];
    b.map((i) => {
      cb[i] = status ? 1 : 0;
    });
    d[h] = status ? s : 0;
    setC(d);
    setBc(cb);
  };

  return (
    <ul>
      <li>
        <p className='head_line'>Sug’orish ishlariga olingan suv miqdori</p>

        <ul>
          <li>
            <p>
              <input
                id='ch1'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 1, 2, [0, 1])}
                checked={c[1] == 0 ? false : true}
              />

              <label htmlFor='ch1'>1.04-8.04.23 y. mln.m3</label>
            </p>
          </li>

          <li>
            <p>
              <input
                id='ch2'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 2, 2, [2, 3])}
                checked={c[2] == 0 ? false : true}
              />

              <label htmlFor='ch2'>
                Kunlik suv sarfi m<sup>3</sup>/s.
              </label>
            </p>
          </li>
        </ul>
      </li>

      <li>
        <p className='head_line'>Sug’orilgan maydon, ming GA</p>

        <ul>
          <li>
            <p>
              <input
                id='ch3'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 3, 2, [4, 5])}
                checked={c[3] == 0 ? false : true}
              />

              <label htmlFor='ch3'>Jami sug’orish ishlari</label>
            </p>
          </li>

          <li>
            <p>
              <input
                id='ch4'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 4, 3, [6, 7, 8])}
                checked={c[4] == 0 ? false : true}
              />

              <label htmlFor='ch4'>
                G'alla ekishdan oldingi sho'r yuvish va nam suvi berish
              </label>
            </p>
          </li>

          <li>
            <p>
              <input
                id='ch5'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 5, 3, [9, 10, 11])}
                checked={c[5] == 0 ? false : true}
              />

              <label htmlFor='ch5'>Galla ekilgan maydon, ming ga</label>
            </p>
          </li>

          <li>
            <p className='head_line'>Sug’orilgan maydon, ming GA</p>

            <ul>
              <li>
                <p>
                  <input
                    id='ch6'
                    type='checkbox'
                    onChange={(e) => changeBox(e.target.checked, 6, 1, [12])}
                    checked={c[6] == 0 ? false : true}
                  />

                  <label htmlFor='ch6'>Reja</label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch7'
                    type='checkbox'
                    onChange={(e) => changeBox(e.target.checked, 7, 1, [13])}
                    checked={c[7] == 0 ? false : true}
                  />

                  <label htmlFor='ch7'>1 kunda</label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch8'
                    type='checkbox'
                    onChange={(e) => changeBox(e.target.checked, 8, 1, [14])}
                    checked={c[8] == 0 ? false : true}
                  />

                  <label htmlFor='ch8'>Jami (01.10.2025 dan)</label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch9'
                    type='checkbox'
                    onChange={(e) => changeBox(e.target.checked, 9, 1, [15])}
                    checked={c[9] == 0 ? false : true}
                  />

                  <label htmlFor='ch9'>Jami ekilgandan boshlab</label>
                </p>
              </li>

              <li>
                <p className='head_line'>Shu jumladan</p>

                <ul>
                  <li>
                    <p>
                      <input
                        id='ch10'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 10, 3, [16, 17, 18])
                        }
                        checked={c[10] == 0 ? false : true}
                      />

                      <label htmlFor='ch10'>Ochiq maydon</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch11'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 11, 3, [19, 20, 21])
                        }
                        checked={c[11] == 0 ? false : true}
                      />

                      <label htmlFor='ch11'>G'oza qator orasi</label>
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <p className='head_line'>Shundan</p>

                <ul>
                  <li>
                    <p>
                      <input
                        id='ch12'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 12, 2, [22, 23])
                        }
                        checked={c[12] == 0 ? false : true}
                      />

                      <label htmlFor='ch12'>1-suv</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch13'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 13, 2, [24, 25])
                        }
                        checked={c[13] == 0 ? false : true}
                      />

                      <label htmlFor='ch13'>2-suv</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch14'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 14, 2, [26, 27])
                        }
                        checked={c[14] == 0 ? false : true}
                      />

                      <label htmlFor='ch14'>3-suv</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch15'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 15, 2, [28, 29])
                        }
                        checked={c[15] == 0 ? false : true}
                      />

                      <label htmlFor='ch15'>4-suv</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch16'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 16, 2, [30, 31])
                        }
                        checked={c[16] == 0 ? false : true}
                      />

                      <label htmlFor='ch16'>5-suv</label>
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <p>
                  <input
                    id='ch17'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 17, 3, [32, 33, 34])
                    }
                    checked={c[17] == 0 ? false : true}
                  />

                  <label htmlFor='ch17'>
                    Sho'r yuvishga yer tayyorlash, ming ga
                  </label>
                </p>
              </li>

              <li>
                <p className='head_line'>Sho'r yuvish, ming ga</p>

                <ul>
                  <li>
                    <p>
                      <input
                        id='ch18'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 18, 1, [35])
                        }
                        checked={c[18] == 0 ? false : true}
                      />

                      <label htmlFor='ch18'>Reja</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch19'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 19, 1, [36])
                        }
                        checked={c[19] == 0 ? false : true}
                      />

                      <label htmlFor='ch19'>1 kunda</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch20'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 20, 1, [37])
                        }
                        checked={c[20] == 0 ? false : true}
                      />

                      <label htmlFor='ch20'>Jami</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch21'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 21, 2, [38, 39])
                        }
                        checked={c[21] == 0 ? false : true}
                      />

                      <label htmlFor='ch21'>1 - sho'r yuvish</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch22'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 22, 2, [40, 41])
                        }
                        checked={c[22] == 0 ? false : true}
                      />

                      <label htmlFor='ch22'>2 - sho'r yuvish</label>
                    </p>
                  </li>
                </ul>
              </li>

              <li>
                <p>
                  <input
                    id='ch23'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 23, 3, [42, 43, 44])
                    }
                    checked={c[23] == 0 ? false : true}
                  />

                  <label htmlFor='ch23'>
                    Baxorgi Pushta va nam suv berish ishlari
                  </label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch24'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 24, 2, [45, 46])
                    }
                    checked={c[24] == 0 ? false : true}
                  />

                  <label htmlFor='ch24'>
                    Tomorqa va boshqa sug'orish ishlari
                  </label>
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li>
        <p>
          <input
            id='ch25'
            type='checkbox'
            onChange={(e) => changeBox(e.target.checked, 25, 1, [47])}
            checked={c[25] == 0 ? false : true}
          />

          <label htmlFor='ch25'>
            Sug’orish ishlarida qatnashgan suvchilar soni
          </label>
        </p>
      </li>
    </ul>
  );
}

export default Fixer;
